import { nonNullish } from "../nullish/nullish"

export function toKnownError(value: unknown): Error {
  if (value instanceof Error) return value
  if (!nonNullish(value)) return new Error("Nullish error")

  // Instantiate new Error attempting to preserve message
  const knownError = new Error(
    "message" in value && typeof value.message === "string"
      ? value.message
      : String(value),
    { cause: value }
  )

  // Preserve SerializedError and other Error like properties
  if (typeof value === "object") {
    if ("name" in value && typeof value.name === "string") {
      knownError.name = value.name
    }
    if ("stack" in value && typeof value.stack === "string") {
      knownError.stack = value.stack
    }
    if ("code" in value) {
      Object.assign(knownError, { code: value.code })
    }
  }

  return knownError
}
